module.exports = __webpack_public_path__ + "static/img/question-mark-1019820_960_720.aff16f73.png";